var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTipi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81 96H38.8175L35.8175 93V57H41.8175V90H78V57H84V93L81 96Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102.183 45H18V51H102.183V45Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69 96H50.8175V66H69V96ZM56.8175 90H63V72H56.8175V90Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M105.183 95.9975H15V52C15 48.555 16.645 45.2675 19.4 43.2L50.815 19.505L50.81 12H68.9925L68.9975 19.5175L99.6325 42.975C103.213 44.9825 105.183 48.18 105.183 52V95.9975ZM99.1825 89.9975V52C99.1825 50.3225 98.3525 49.095 96.57 48.14L96.3575 48.025L63 22.4825V18H56.815V22.495L23.005 47.995C21.745 48.94 20.9975 50.435 20.9975 52V89.9975H99.1825Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63 24H57V66H63V24Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1825 90H48V96H72.1825V90Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8775 50.1225L60 31.2425V27H59.8175V31.2425L40.9375 50.1225L36.695 45.8775L53.8175 28.7575V21H66V28.7575L83.1225 45.8775L78.8775 50.1225Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTipi);
export default __webpack_public_path__ + "static/media/Tipi.f5c966ed.svg";
export { ForwardRef as ReactComponent };